import { render, staticRenderFns } from "./info_adicional.vue?vue&type=template&id=ccf54306&"
import script from "./info_adicional.vue?vue&type=script&lang=js&"
export * from "./info_adicional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ccf54306', component.options)
    } else {
      api.reload('ccf54306', component.options)
    }
    module.hot.accept("./info_adicional.vue?vue&type=template&id=ccf54306&", function () {
      api.rerender('ccf54306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Map/Details/info_adicional.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/Map/Details/info_adicional.vue
// module id = dF6N
// module chunks = 0